export default {"src":"/_next/static/media/safety.5792b45a.svg","height":152,"width":152};